import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogClose, MatDialogModule } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import {Router} from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { UserDTO } from 'src/app/interfaces/user';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-confirm-dialog',
    imports: [ MatDialogClose, MatButtonModule, MatDialogModule, CommonModule],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {

  isLoggedIn: boolean;
  user: UserDTO;
  role: string;
  isOk: boolean;
  question: string;
  data: any;

  constructor(private router: Router, private tokenStorageService: TokenStorageService, public dialogRef: MatDialogRef<ConfirmDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) data) { 
    this.data = data;  
  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.role = this.user.role;
      this.isOk = true;
    } else {
      this.isOk = false;
    } 
    if (!this.isOk) {
      this.router.navigate(['home']);
    }
  }

  ngOnInit(): void {
    this.isAuthorized();
  }

  save() {
    this.dialogRef.close();
  }

}
